/* eslint-disable no-undef */
import Vue from "vue";
import VueRouter from "vue-router";
import VueRouterBackButton from "vue-router-back-button";
//import Login from "@/components/Login";
import routes from "./routes/index.js";
import store from "../store";
import CartService from "~/service/cartService";

Vue.use(VueRouter);
const router = new VueRouter({
  mode: process.env.VUE_APP_ROUTER_MODE, // "hash" per Cordova. "History" per Browser
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    //savedPosition funziona solo quando navigo con i tasti del browser e non tramite i link dell'app
    if (savedPosition) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(savedPosition);
        }, 500);
      });
    } else {
      return { x: 0, y: 0 };
    }
  }
});

window.popStateDetected = false;
window.addEventListener("popstate", () => {
  window.popStateDetected = true;
});

async function isLoggedInCall(operation) {
  let isLogged = await CartService.isLoggedIn(operation);
  return isLogged;
}

let isFirstNavigation = true;
async function checkUserOnFirstNavigation() {
  if (isFirstNavigation === true) {
    try {
      let isLoggedIn = await isLoggedInCall("checkUserOnFirstNavigation");
      if (isLoggedIn) {
        await store.dispatch("cart/loadCart");
      }
    } catch (error) {
      console.error("Error during checkUserOnFirstNavigation:", error);
    } finally {
      isFirstNavigation = false;
      store.commit("cart/SET_AUTH_READY");
    }
  }
}

router.beforeEach(async (to, from, next) => {
  await checkUserOnFirstNavigation(to, from);

  let dialog = document.querySelector("div.v-dialog__content");
  if (dialog && dialog.length > 0) {
    const IsItABackButton = window.popStateDetected;
    window.popStateDetected = false;
    if (IsItABackButton) {
      vm.$dialog.clearDialogs();
      next(false);
      return "";
    }
    next();
  } else {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (
        window.sessionStorage.getItem("is-authenticated") ||
        window.sessionStorage.getItem("X-Ebsn-Session") ||
        window.localStorage.getItem("X-Ebsn-Account")
      ) {
        next();
      } else if (store && store.getters["cart/isAuthenticated"] == false) {
        next({ name: "Home" });
      } else {
        if (to.matched.some(record => record.meta.isAdmin)) {
          if (store && store.getters.isSsoUser == true) {
            next();
          } else {
            next({
              name: "userboard"
            });
          }
        } else {
          next();
        }
      }
    } else {
      next();
    }
  }
});
Vue.use(VueRouterBackButton, { router });

export default router;
